import React from 'react';

import { PageContainer, TwoColumnLayout } from './DataDetailPage.styles';

export interface DataDetailPageProps {
  children?: React.ReactNode;
  fullScreen?: boolean;
}

export const DataDetailPage: React.FC<DataDetailPageProps> = ({
  children,
  fullScreen = false,
}) => {
  return (
    <PageContainer $fullScreen={fullScreen}>
      <TwoColumnLayout>{children}</TwoColumnLayout>
    </PageContainer>
  );
};

export default DataDetailPage;
